import { Company, CompanyInvitation as CompanyInvitationGraphQL } from '@neo.tax/shared/graphql';

export type CompanyIdAndShortName = Pick<Company, 'id' | 'shortName'>;

export type CompanyInvitation = Pick<
  CompanyInvitationGraphQL,
  '__typename' | 'id' | 'email' | 'scope' | 'acceptedAt' | 'companyId'
>;

/*
  In company member table, we display
  - organization members
  - invited members to the organization
  - company members
  - invited members to the company
  the type of the scope in them from backend can be OrganizationScope or CompanyScope
  We convert the scope to CompanyMemberItemScope to display in the table
*/
export enum OrganizationMemberItemScope {
  ADMIN = 'ADMIN',
  MEMBER = 'MEMBER',
  NON_FINANCIAL = 'NON_FINANCIAL',
}

// Derived state values returned by the server's InvitationStateRules.deriveState.
// Typed as a string literal union so table renderers can branch on it without reimporting
// the server-side enum.
export type OrganizationInvitationDerivedState = 'PENDING' | 'EXPIRED' | 'REVOKED' | 'ACCEPTED';

export type OrganizationMemberTableItemMember = {
  id: string;
  email: string;
  fullName: string;
  companies: { id: string; shortName: string }[];
  scope: OrganizationMemberItemScope;
  type: 'ORGANIZATION_MEMBER';
};

export type OrganizationMembersTableItemInvitation = {
  id: string;
  email: string;
  fullName: string;
  companies: { id: string; shortName: string }[];
  scope: OrganizationMemberItemScope;
  // Derived on the backend via InvitationStateRules; optional because child CompanyInvitation
  // rows inherit their state from the parent OrganizationInvitation and don't carry it on the wire.
  derivedState?: OrganizationInvitationDerivedState;
  expiresAt?: string | null;
  revokedAt?: string | null;
  acceptedAt?: string | null;
  type: 'INVITED_ORGANIZATION_MEMBER';
};

export type OrganizationMembersTableItem = OrganizationMemberTableItemMember | OrganizationMembersTableItemInvitation;
